import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8 mb-10" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-title fw-bolder text-dark text-hover-primary fs-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laporan, (data) => {
      return (_openBlock(), _createElementBlock("div", {
        key: data,
        class: "col-xl-6"
      }, [
        _createElementVNode("div", {
          class: "card h-150px bgi-no-repeat cursor-pointer",
          style: {"background-image":"url('media/svg/shapes/abstract-4.svg')","background-position":"right top","background-size":"30%"},
          onClick: ($event: any) => (
          _ctx.displayReport(data.id, data.title, data.reportType, data.reportName)
        )
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", _hoisted_4, _toDisplayString(data.title), 1)
          ])
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}